/**
 * TASK-896 / TASK-900 — display phones for map + visited listings.
 * TASK-951 — display text is a US number. Stored digits stay digits.
 */

/** (321) 352-4048. Returns the trimmed input when it is not 10 US digits. */
export function formatUsPhoneDisplay(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  const national =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (national.length !== 10) return String(raw || '').trim();
  return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
}

/** Map pin: Voice DID only when present; else google_phone || phone_number. */
export function mapListingDisplayPhone(shop) {
  const voice = (shop?.voice_phone || '').trim();
  if (voice) {
    return { number: formatUsPhoneDisplay(voice), href: telHref(voice) };
  }
  const company = (shop?.google_phone || shop?.phone_number || '').trim();
  if (!company) return null;
  return { number: formatUsPhoneDisplay(company), href: telHref(company) };
}

export function telHref(phone) {
  const digits = String(phone || '').replace(/[^\d+]/g, '');
  if (!digits) return null;
  return digits.startsWith('+') ? `tel:${digits}` : `tel:${digits}`;
}
